import { useEffect } from 'react'

export function useScrollToTopOnChange<T>(valueToWatch: T): void {
  useEffect(() => window.scrollTo(0, 0), [valueToWatch])
}
